export default __webpack_public_path__ + "static/laptop-xs-875ef5a5e65afdb4a63d0c2e59ce28e1.png";